import request from '@/util/request';
import qs from 'qs';
// 便民服务中心
export const getList = (params, options) =>
request.get('/api/v4ward/convenience/service/center/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/convenience/service/center/detail', Object.assign({}, options, { params }))

export const remove = (params, options) =>
request.post('/api/v4ward/convenience/service/center/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/convenience/service/center/save', params,options)

export const update = (params, options) =>
request.post('/api/v4ward/convenience/service/center/update', params,options)
